import React from 'react';

import { ErrorBoundarySuspense } from 'src/components/suspenses/ErrorBoundarySuspense';
import { Card } from 'src/components/ui/card';
import { ForecastPaginatedProductDetails } from 'src/features/forecastPaginated/forecastPaginatedDetails/ForecastPaginatedProductDetails';
import { ForecastPaginatedProductDetailsSkeleton } from 'src/features/forecastPaginated/forecastPaginatedDetails/ForecastPaginatedProductDetailsSkeleton';
import { QUERY_KEY_SKU_DETAIL } from 'src/keys';
import { cn } from 'src/lib/utils';

type ForecastPaginatedProductDetailsContainerProps = {
  sku?: string | null;
  fullWidth?: boolean;
  validatedAt?: string | null;
};

export function ForecastPaginatedProductDetailsContainer({
  sku,
  fullWidth = false,
  validatedAt,
}: ForecastPaginatedProductDetailsContainerProps) {
  return (
    <>
      {sku ? (
        <ErrorBoundarySuspense
          errorFallbackWrapper={
            <Card
              className={cn(
                'flex h-44 w-full flex-col gap-y-4 p-4',
                fullWidth && 'lg:w-full',
              )}
            />
          }
          queryKey={[QUERY_KEY_SKU_DETAIL, sku]}
          loadingFallback={<ForecastPaginatedProductDetailsSkeleton />}
        >
          <ForecastPaginatedProductDetails
            sku={sku}
            fullWidth={fullWidth}
            validatedAt={validatedAt}
          />
        </ErrorBoundarySuspense>
      ) : (
        <ForecastPaginatedProductDetailsSkeleton />
      )}
    </>
  );
}
